module.exports = __webpack_public_path__ + "img/liveguide_f10i_460x311.22056c8f.png";